import { Injectable, ViewContainerRef } from '@angular/core';
import { LMDialogButtonKey, LMUniqueIdService } from '@app/utils';
import { LMKeyboardShortcutsDialogComponent } from '@app/components';
import { LMModalDialogWrapperRef, LMModalWrapperService } from '@app/services';

@Injectable()
export class LMKeyboardShortcutsDialogService {

  private dialog: LMModalDialogWrapperRef<any> | undefined;

  constructor(
    private lmUniqueIdService: LMUniqueIdService,
    private lmModalWrapperService: LMModalWrapperService,
  ) { }

  public openKeyboardShortcutsDialog(placeHolder: ViewContainerRef) {
    const dialogId = 'KeyboardShortcuts';
    const buttons = [ {
      id: this.lmUniqueIdService.uniqueId([ dialogId, LMDialogButtonKey.OK ]),
      text: Soho.Locale.translate(LMDialogButtonKey.OK),
      click: (e: any, modal: { isCancelled: boolean; close: (arg0: boolean) => void; }) => {
        modal.isCancelled = true;
        modal.close(true);
      },
      isDefault: true
    } ];

    this.dialog = this.lmModalWrapperService
      .modal(LMKeyboardShortcutsDialogComponent, { fullsize: 'responsive' })
      .buttons(buttons)
      .title(Soho.Locale.translate('KeyboardShortcuts'))
      .open();
  }
}
